import Vue from 'vue'
import * as types from './mutation-types'

export default {
  [types.SAVE_BEFORE_LOGIN_INFO] (state, beforLoginInfo) {
    console.log('mutaion', types.SAVE_BEFORE_LOGIN_INFO, beforLoginInfo)
    Vue.set(state, 'beforLoginInfo', beforLoginInfo)
    console.log('mutaion done', state)
  },
  [types.LOAD_BEFORE_LOGIN_INFO] (state) {

  }
}
